import { useMutation } from '@apollo/client';
import { addDemographicAudienceInsightMutation } from 'api/mutations/customInsight';
import {
  DemographicSettings,
  DemographicInsightPresentationMode,
} from 'modules/domains/segmentation';

type AddCustomInsightResponse = {
  addDemographicAudienceInsight: { success: boolean };
};

type AddCustomInsightRequest = DemographicSettings;

export const useAddCustomDemographicInsight = () => {
  const [addDemographicAudienceInsight, { data, loading, called, error }] = useMutation<
    AddCustomInsightResponse,
    AddCustomInsightRequest
  >(addDemographicAudienceInsightMutation);

  const addCustomDemographicInsight = (
    contactProperty: string,
    presentationMode: DemographicInsightPresentationMode,
  ) => {
    addDemographicAudienceInsight({ variables: { contactProperty, presentationMode } });
  };

  return {
    addCustomDemographicInsight,
    data: data ?? null,
    isLoading: loading,
    isCalled: called,
    isSuccess: !loading && !!data?.addDemographicAudienceInsight.success,
    isError: !loading && (!data?.addDemographicAudienceInsight.success || !!error),
  };
};
